import { jsx as _jsx } from "react/jsx-runtime";
export const String = (props) => {
    return (_jsx("input", { type: "text", size: 16, value: props.value, onChange: e => props.setValue(e.target.value) }));
};
